// Compartilhado entre routes/users.tsx (aba CLIENTE do dialog Editar/Criar
// Usuário) e components/user-import-dialog.tsx (importação em massa por
// planilha) — extraído daqui pra evitar duplicar o mapeamento de 19 campos
// entre os dois lugares. Mapeia GpsDriveClientProfile (chaves em inglês, ver
// gpsdrive-client-profile.service.ts) <-> `CliState` (chaves em português,
// forma que a aba CLIENTE já usava antes do backend existir).
import type { AccountType } from "@/services/gpsdrive-users.service";
import type {
  GpsDriveClientProfile,
  UpdateGpsDriveClientProfileInput,
} from "@/services/gpsdrive-client-profile.service";

export type CliState = {
  cpfCnpj: string;
  razaoSocial: string;
  nomeContrato: string;
  rg: string;
  dataNascimento: string;
  cep: string;
  endereco: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  celular: string;
  valorMensalidade: string;
  foneFixo: string;
  diaVencimento: string;
  emailCobranca: string;
  rendaFaturamento: string;
  numeroSuporte: string;
  notas: string;
};

export function blankCliState(): CliState {
  return {
    cpfCnpj: "",
    razaoSocial: "",
    nomeContrato: "",
    rg: "",
    dataNascimento: "",
    cep: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    celular: "",
    valorMensalidade: "",
    foneFixo: "",
    diaVencimento: "",
    emailCobranca: "",
    rendaFaturamento: "",
    numeroSuporte: "",
    notas: "",
  };
}

export function clientProfileToCliState(p: GpsDriveClientProfile | null | undefined): CliState {
  return {
    cpfCnpj: p?.cpfCnpj ?? "",
    razaoSocial: p?.companyName ?? "",
    nomeContrato: p?.contractName ?? "",
    rg: p?.rg ?? "",
    dataNascimento: p?.birthDate ? p.birthDate.slice(0, 10) : "",
    cep: p?.postalCode ?? "",
    endereco: p?.street ?? "",
    numero: p?.number ?? "",
    complemento: p?.complement ?? "",
    bairro: p?.neighborhood ?? "",
    cidade: p?.city ?? "",
    estado: p?.state ?? "",
    celular: p?.mobilePhone ?? "",
    valorMensalidade: p?.monthlyFee ?? "",
    foneFixo: p?.landlinePhone ?? "",
    diaVencimento: p?.dueDay != null ? String(p.dueDay) : "",
    emailCobranca: p?.billingEmail ?? "",
    rendaFaturamento: p?.incomeRevenue ?? "",
    numeroSuporte: p?.supportPhone ?? "",
    notas: p?.notes ?? "",
  };
}

export function cliStateToClientProfilePayload(cli: CliState): UpdateGpsDriveClientProfileInput {
  return {
    cpfCnpj: cli.cpfCnpj || null,
    companyName: cli.razaoSocial || null,
    contractName: cli.nomeContrato || null,
    rg: cli.rg || null,
    birthDate: cli.dataNascimento || null,
    postalCode: cli.cep || null,
    street: cli.endereco || null,
    number: cli.numero || null,
    complement: cli.complemento || null,
    neighborhood: cli.bairro || null,
    city: cli.cidade || null,
    state: cli.estado || null,
    mobilePhone: cli.celular || null,
    monthlyFee: cli.valorMensalidade || null,
    landlinePhone: cli.foneFixo || null,
    dueDay: cli.diaVencimento ? Number(cli.diaVencimento) : null,
    billingEmail: cli.emailCobranca || null,
    incomeRevenue: cli.rendaFaturamento || null,
    supportPhone: cli.numeroSuporte || null,
    notes: cli.notas || null,
  };
}

// Rótulos do select "Grupo do usuário" (pedido 2026-09-03) — ordem fixa,
// mesma de ACCOUNT_TYPES em gpsdrive-users.service.ts. "usuario" → rótulo
// "Cliente" (pedido 2026-09-10) — accountType em si continua "usuario" no
// banco/API (nunca renomear a CHAVE, só o texto mostrado).
export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  admin: "Admin",
  usuario: "Cliente",
  funcionario: "Funcionário",
  motorista: "Motorista",
  revenda: "Revenda",
};
